import React from "react";

const Cancelled = () => {
  return <div>Payment Cancelled</div>;
};

export default Cancelled;
